<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'imgtextlist',
})
</script>
<template>
    <div v-if="data">
      <contenttitle :data="data" ></contenttitle>

      <a-row :gutter="30" v-for="(item,i) in data.child" :key="i" class="margin-tb-lg rows content-box">
        <template v-if="i%2==0">
            <a-col :md="{span:10}" :sm="{span:24}">
               <img :src="addip(item.pic)" class="box-shadow-lg" style="width:100%;height:auto;" />
            </a-col>
            <a-col :md="{span:14}" :sm="{span:24}">
              <h3>{{ item.name }}</h3>
              <h4 v-if="item.sub">{{ item.name }}</h4>
              <h5 v-if="item.contents" v-html="item.contents"></h5>
              <h4 v-if="item.url" class="text-right padding-tb-lg">
                <a  :href="item.url" class="btn-primary">更多 <ArrowRightOutlined /></a>
              </h4>
            </a-col>
        </template>
        <template  v-else>
            <a-col :md="{span:14}" :sm="{span:24}">
              <h3>{{ item.name }}</h3>
              <h4 v-if="item.sub">{{ item.name }}</h4>
              <h5 v-if="item.contents" v-html="item.contents"></h5>
              <h4 v-if="item.url" class="text-right padding-tb-lg">
                <a  :href="item.url" class="btn-primary">更多 <ArrowRightOutlined /></a>
              </h4>
            </a-col>
            <a-col :md="{span:10}" :sm="{span:24}">
               <img :src="addip(item.pic)" class="box-shadow-lg" style="width:100%;height:auto;" />
            </a-col>
        </template>
      </a-row>
    </div>
</template>
<script setup lang="ts" name="imgtextlist">
import {defineComponent,defineProps ,ref} from 'vue';
import {addip,colors} from '@/utils/util'
import {ArrowRightOutlined}  from '@ant-design/icons-vue'
defineProps({
  data:Object
})
</script>
<style lang="less">
.imgtextlist{
   .rows{padding-top:50px;padding-bottom: 50px;}
   .rows:nth-child(2n+1){background-color:rgba(200,200,200,.1)}
}
</style>
